import { render } from "./HowItWorks.vue?vue&type=template&id=0ded1f0c&scoped=true"
const script = {}

import "./HowItWorks.vue?vue&type=style&index=0&id=0ded1f0c&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ded1f0c"]])

export default __exports__